import { Module } from 'vuex';
import {RootState} from "@/store/types";
import {UserRolesState} from "@/store/user_management/roles/types";
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: UserRolesState = {
  userRoles: [],
}

export const userRoles: Module<UserRolesState, RootState> = {
  state,
  getters,
  actions,
  mutations
}